import {
  withTranslation,
} from 'react-i18next';

import ChampionshipResultTablesSectionView from './ChampionshipResultTablesSectionView';
import './ChampionshipResultTablesSection.css';

const TranslatedComponent = withTranslation()(ChampionshipResultTablesSectionView);

const Component = TranslatedComponent;

export default Component;
